import { useState } from "react";
import moment from "moment";
import toast from "react-hot-toast";

export default function Filter({ interest }) {
  const [start, setStart] = useState(
    moment().startOf("week").format("YYYY-MM-DD")
  );
  const [end, setEnd] = useState(moment().endOf("week").format("YYYY-MM-DD"));

  const handleFilter = () => {
    try {
      interest?.(start, end);
    } catch {
      toast.error("Invalid selection");
    }
  };

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        padding: "10px 16px",
        background: "var(--background)",
        color: "var(--text)",
      }}
    >
      {/* LEFT SIDE */}
      <div style={{ display: "flex", alignItems: "center", gap: "12px" }}></div>

      {/* RIGHT SIDE */}
      <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
        {/* DATE PICKERS */}
        <input
          type="date"
          value={start}
          onChange={(e) => setStart(e.target.value)}
          max={moment().format("YYYY-MM-DD")}
          style={{
            background: "var(--background)",
            border: "2px solid var(--hover)",
            color: "var(--text)",
            padding: "6px 10px",
            borderRadius: "6px",
          }}
        />

        <input
          type="date"
          value={end}
          onChange={(e) => setEnd(e.target.value)}
          max={moment().format("YYYY-MM-DD")}
          style={{
            background: "var(--background)",
            border: "2px solid var(--hover)",
            color: "var(--text)",
            padding: "6px 10px",
            borderRadius: "6px",
          }}
        />

        {/* FILTER BTN */}
        <button
          onClick={handleFilter}
          className="px-4 py-1.5 bg-[var(--primary)] text-white rounded-full text-sm font-semibold shadow"
        >
          FILTER
        </button>
      </div>
    </div>
  );
}
